<div class="gpd-config-section">
  <div>
    <span class="gpd-config-section-title">Logo</span>
    <p class="gpd-config-section-description" i18n="@@logo-hint">Add logo to show it in the application</p>
  </div>

  <div class="logo-container">
    <div class="logo-item">
      <span i18n="@@big">Big</span>
      <img [src]="largeLogo" *ngIf="largeLogo" class="logo-preview" />
      <dx-file-uploader
        *ngIf="!largeLogo"
        [multiple]="false"
        [uploadMode]="'useForm'"
        [accept]="'image/*'"
        [showFileList]="false"
        (onValueChanged)="onFileSelected($event, 'large')"
        [selectButtonText]="searchText"
        [labelText]="''"
      >
      </dx-file-uploader>
      <app-gpd-button
        type="tertiary-text"
        icon="delete"
        iconColor="var(--color-red-500)"
        [iconSize]="20"
        *ngIf="largeLogo"
        (onClick)="deleteLogo('large');"
        i18n-hint="@@delete"
        hint="Delete"
      ></app-gpd-button>

      <dx-popup
        [visible]="largeCropperVisible"
        width="500px"
        height="auto"
        (onHiding)="largeCropperVisible = false"
      >
        <app-image-cropper
          [file]="selectedLargeFile"
          [aspectRatio]="3/1"
          (croppedImageEmitter)="saveCroppedImage($event, 'large')"
        />
      </dx-popup>
    </div>

    <div class="logo-item">
      <span i18n="@@small">Small</span>
      <img [src]="smallLogo" class="logo-preview small" *ngIf="smallLogo" />
      <dx-file-uploader
        *ngIf="!smallLogo"
        [uploadMode]="'useForm'"
        [multiple]="false"
        [accept]="'image/*'"
        [showFileList]="false"
        (onValueChanged)="onFileSelected($event, 'small')"
        [selectButtonText]="searchText"
        [labelText]="''"
      >
      </dx-file-uploader>
      <app-gpd-button
        type="tertiary-text"
        icon="delete"
        iconColor="var(--color-red-500)"
        [iconSize]="20"
        *ngIf="smallLogo"
        (onClick)="deleteLogo('small');"
        i18n-hint="@@delete"
        hint="Delete"
      ></app-gpd-button>
      <dx-popup
        [visible]="smallCropperVisible"
        width="500px"
        height="auto"
        (onHiding)="smallCropperVisible = false"
      >
        <app-image-cropper
          [file]="selectedSmallFile"
          [aspectRatio]="1"
          (croppedImageEmitter)="saveCroppedImage($event, 'small')"
        >
        </app-image-cropper>
      </dx-popup>
    </div>
  </div>
</div>
